import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useBackgroundTask } from '../contexts/BackgroundTaskContext';
import notificationIcon from '../assets/icons8-notification-100.png';
import '../styles/NotificationCenter.css';

const NotificationCenter = () => {
  const navigate = useNavigate();
  const { getCompletedTasks, getCompletedCount, removeTask } = useBackgroundTask();
  const [isOpen, setIsOpen] = useState(false);
  const completedTasks = getCompletedTasks();
  const completedCount = getCompletedCount();

  const handleTaskClick = (task) => {
    // Close notification dropdown immediately
    setIsOpen(false);

    // Determine which analysis page to navigate to based on task type
    if (task.title.includes('MRCA') || task.title.includes('Isolate')) {
      // MRCA Analysis (all 4 types: Hierarchical, Comparative, Single Level, Isolate Pair)
      navigate('/Analysis?tool=MRCAFinder');

      // Store task data in window as backup
      window.viewMRCATask = task;

      // Emit event to load results on the MRCA Finder page
      setTimeout(() => {
        window.dispatchEvent(
          new CustomEvent('viewMRCAResults', {
            detail: { task }
          })
        );
      }, 600);

      // Auto-remove the notification after viewing
      setTimeout(() => {
        removeTask(task.id);
      }, 700);
    } else if (task.title.includes('Host Comparison')) {
      // Host Comparison Analysis
      navigate('/Analysis?tool=hostComparison');

      // Store task data in window as backup
      window.viewComparisonTask = task;

      // Emit event to load results on the Host Comparison page
      setTimeout(() => {
        window.dispatchEvent(
          new CustomEvent('viewComparisonResults', {
            detail: { task }
          })
        );
      }, 600);

      // Auto-remove the notification after viewing
      setTimeout(() => {
        removeTask(task.id);
      }, 700);
    }
  };

  return (
    <div className="notification-center">
      {/* Bell Icon Button */}
      <button
        className="notification-bell"
        onClick={() => setIsOpen(!isOpen)}
        title="View completed analysis jobs"
      >
        <img src={notificationIcon} alt="notification" className="bell-icon" />
        {completedCount > 0 && (
          <span className="notification-badge">{completedCount}</span>
        )}
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <div className="notification-dropdown">
          <div className="notification-header">
            <h3 className="notification-title">Completed Analysis</h3>
            <button
              className="close-btn"
              onClick={() => setIsOpen(false)}
            >
              ×
            </button>
          </div>

          {completedTasks.length === 0 ? (
            <div className="notification-empty">
              <p>No completed analysis yet</p>
            </div>
          ) : (
            <div className="notification-list">
              {completedTasks.map(task => (
                <div key={task.id} className={`notification-item notification-item--${task.status}`}>
                  <div className="notification-item-content">
                    <p className="notification-item-title">{task.title}</p>
                    {task.resultMessage && (
                      <p className="notification-item-message">{task.resultMessage}</p>
                    )}
                  </div>
                  <div className="notification-item-actions">
                    {task.status === 'completed' && (
                      <button
                        className="view-btn"
                        onClick={() => handleTaskClick(task)}
                        title="View results"
                      >
                        View
                      </button>
                    )}
                    <button
                      className="remove-btn"
                      onClick={() => removeTask(task.id)}
                      title="Remove"
                    >
                      ×
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* Backdrop to close menu */}
      {isOpen && (
        <div
          className="notification-backdrop"
          onClick={() => setIsOpen(false)}
        />
      )}
    </div>
  );
};

export default NotificationCenter;
